var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"assessList"},[_c('div',{staticClass:"title"},[_vm._v("人才测评")]),_c('evaluation-list',{attrs:{"navPage":_vm.navPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }